module.exports = __webpack_public_path__ + "401b1012f3dc1bc71b3cfeec69117199.png";